import React from 'react'
import { Select, Form, Button, Divider, message, Tabs, Anchor, Spin, Pagination, Tooltip, DatePicker, Steps } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import { ajaxApi, fileDownloadApiNew, getMethod } from '@/server/index'
import {getParmUrl} from '@/public/utils'
import moment from 'moment'
import 'moment/locale/zh-cn'
import _lodash from 'lodash'
import common from '@/public/common'
import styles from './medical-equipmentn-onhaitao.module.less'
const Option = Select.Option
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
const { Step } = Steps
class RegistrationCertificateInformation extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      detailsData: null
    }
  }

  componentDidMount () {
    let {detailsData} = this.state
    detailsData = this.props.detailsData
    this.setState({
      detailsData
    })
  }

  componentWillReceiveProps (nextprops) {
    let {detailsData} = this.state
    detailsData = nextprops.detailsData
    this.setState({
      detailsData
    })
  }

  render () {
    let {detailsData} = this.state
    return (
      <div>
        <div style={{ display: 'flex', border: '1px solid #d9d9d9' }}>
          <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', paddingLeft: '13%' }}>
              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>产品注册证号：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.regist_number : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>规格型号：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.spec_type : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>成分：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.element : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>注册证有效期：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.regist_useful_life + '年' : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>生产企业：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.create_company : '-'}
                </span>
              </section>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>产地：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData && detailsData.item_info.origin_place ? detailsData.item_info.origin_place : '-'}
                </span>
              </section>

              <section className={styles.publicsection} style={{display: 'flex'}}>
                <div>
                  <span className={styles.publlictitle}><span className={styles.required}>*</span>主要功能：</span>
                </div>
                <div>
                  <span style={{ width: 244, marginRight: '0px' }} >
                    {detailsData ? detailsData.item_info.main_function : ''}
                  </span>
                </div>
              </section><br/>

              <section className={styles.publicsection}>
                <span className={styles.publlictitle}><span className={styles.required}>*</span>存储要求：</span>
                <span style={{ width: 244, marginRight: '0px' }} >
                  {detailsData ? detailsData.item_info.storage_request : ''}
                </span>
              </section>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default RegistrationCertificateInformation



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/commoditydetails/completeinformationdetails/medicalequipmentnonhaitaodetails/registration-certificate-information.js